module.exports = __webpack_public_path__ + "static/media/dokify-logo-small.f0e0fcdf.svg";